import authors from 'utils/author-data.js';
import * as React from 'react';
export default {
  authors,
  React
};